;(function () {
  'use strict'
  angular
    .module('contrast.application.protection')
    .controller('AppProtectionCtrl', AppProtectionCtrl)

  function AppProtectionCtrl(
    $scope,
    $uibModal,
    $filter,
    $routeParams,
    $timeout,
    $q,
    $interval,
    $translate,
    permissions,
    ErrorService,
    LoadFilterRouteService,
    UserService,
    ProtectionRulesFactory,
    ApplicationFactory,
    BlockingPerimeterModalService,
    csBetaRulesService,
    PROTECTION_MODES,
    SERVER_ENVIRONMENT_LIST
  ) {
    'ngInject'

    var translGlobal = {
      title_remediationPolicy_allRules: $translate.instant(
        'title_remediationPolicy_allRules'
      )
    }

    var PROTECT_RULE_INDEX = 0
    var CVE_SHIELD_INDEX = 1
    var VIRTUAL_PATCH_INDEX = 2
    var FILTER_TYPES = {
      ALL: 'ALL',
      PROTECT_RULE: 'PR',
      CVE_SHIELD: 'CVE',
      VIRTUAL_PATCH: 'VR'
    }

    // needed to support the link introduced by
    // https://github.com/Contrast-Security-Inc/attack-events-mfe/pull/65/files#diff-da61ace75af8dade9b1996949786dc610239d46393c7f783248e972d7b7303faR73
    var _searchKeywords = $routeParams.withRule
      ? $routeParams.protectionRuleId
      : ''

    var numPerLoaded = 15
    var delay = 500 //ms to simulate the infinite scroll
    var typeOrder = ['Protect Rule', 'CVE Shield', 'Virtual Patch']

    // needed to support the link introduced by
    // https://github.com/Contrast-Security-Inc/attack-events-mfe/pull/65/files#diff-da61ace75af8dade9b1996949786dc610239d46393c7f783248e972d7b7303faR73
    var ruleId = $routeParams.withRule
      ? undefined
      : $routeParams.protectionRuleId

    angular.extend($scope, {
      appId: $routeParams.appId,
      selectedRules: [],
      displayedRules: [],
      filteredRules: [],
      rules: [],
      quickFilters: [],
      selectedQuickFilter: {
        name: translGlobal.title_remediationPolicy_allRules,
        filterType: 'ALL',
        count: '?'
      },
      appPromise: undefined,
      policyPromise: undefined,
      tooltip_environment: '',
      app_servers: {
        dev: undefined,
        qa: undefined,
        prod: undefined,
        protection_dev: undefined,
        protection_qa: undefined,
        protection_prod: undefined
      },

      searchKeywords: searchKeywords,

      model: {
        busy: true,
        selectAllCheckbox: false,
        row: 'type'
      }
    })

    angular.extend($scope, {
      order: order,
      onSelectAll: onSelectAll,
      selectAll: selectAll,
      deselectAll: deselectAll,
      toggleSelection: toggleSelection,
      moveToServer: moveToServer,
      typeSelected: typeSelected,
      checkPermission: checkPermission,
      openChangeModeModal: openChangeModeModal,
      quickFilterSelect: quickFilterSelect,
      loadByScroll: loadByScroll,
      determineNoServerTooltip: determineNoServerTooltip,
      determineNoProtectionTooltip: determineNoProtectionTooltip,
      getModesForRule: getModesForRule,
      getUniqueParentIds: getUniqueParentIds,
      hasMultipleRules: hasMultipleRules,
      getRulesByParentId: getRulesByParentId,
      getParentRuleName: getParentRuleName,
      getSemanticRuleNamePrefix: getSemanticRuleNamePrefix,
      getSemanticRuleNameSuffix: getSemanticRuleNameSuffix,
      isNewRule: isNewRule
    })

    function init() {
      if (angular.isUndefined(ruleId)) {
        getRules()
        getAppServers()
      } else {
        ProtectionRulesFactory.getEnvProtectionRule($scope.appId, ruleId).then(
          function (response) {
            _searchKeywords = response.data.rule.name
            getRules()
            getAppServers()
          }
        )
      }
    }

    function getUniqueParentIds(rules) {
      return rules
        .map(function (rule) {
          return rule.parent_rule_uuid
        })
        .filter(function (id, index, arr) {
          return arr.indexOf(id) == index
        })
    }

    function getParentRuleName(parentId) {
      var rule = $scope.filteredRules.find(function (rule) {
        return rule.parent_rule_uuid === parentId
      })
      return rule ? rule.parent_rule_name : ''
    }

    function getRulesByParentId(parentId) {
      return $scope.filteredRules.filter(function (rule) {
        return rule.parent_rule_uuid === parentId
      })
    }

    function getSemanticRuleNamePrefix(semanticRuleName) {
      return semanticRuleName.split('-')[1]
    }

    function getSemanticRuleNameSuffix(semanticRuleName) {
      return semanticRuleName.split('-')[0]
    }

    function hasMultipleRules(parentId) {
      return getRulesByParentId(parentId).length > 1
    }

    function getRules() {
      $scope.displayedRules = []
      $scope.rules = []
      $scope.selectedRules = []
      $scope.model.selectAllCheckbox = false
      $scope.policyPromise = ProtectionRulesFactory.getProtectionPolicies(
        $scope.appId
      ).then(
        function (response) {
          $scope.rules = response.data.rules

          calculateRules(_searchKeywords)
          calculateQuickFilters()
          loadRules(0, numPerLoaded)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getModesForRule(rule) {
      var modesToRemove = []

      if (!rule.is_monitor_at_perimeter) {
        modesToRemove.push('MONITOR_PERIMETER')
      } else {
        modesToRemove.push('BLOCKING')
        modesToRemove.push('MONITORING')
      }
      if (!rule.can_block_at_perimeter) {
        modesToRemove.push('BLOCKING_PERIMETER')
      }
      if (!rule.can_block) {
        modesToRemove.push('BLOCKING')
      }

      return PROTECTION_MODES.filter(function (mode) {
        return !_.includes(modesToRemove, mode.value)
      })
    }

    function getAppServers() {
      $scope.appPromise = ApplicationFactory.getServersBreakdown(
        $scope.appId
      ).then(
        function (response) {
          $scope.app_servers.dev = response.data.development
          $scope.app_servers.qa = response.data.qa
          $scope.app_servers.prod = response.data.production
          $scope.app_servers.protection_dev =
            response.data.protected_development
          $scope.app_servers.protection_qa = response.data.protected_qa
          $scope.app_servers.protection_prod =
            response.data.protected_production
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      $scope.displayedRules = []
      calculateRules(_searchKeywords)
      calculateQuickFilters()
      loadRules(0, numPerLoaded)
      return _searchKeywords
    }

    function filterFunction(rule) {
      return (
        rule.name.toLowerCase().indexOf(_searchKeywords.toLowerCase() || '') !==
          -1 ||
        (rule.uuid ? rule.uuid.indexOf(_searchKeywords || '') !== -1 : false)
      )
    }

    function loadRules(offset, limit) {
      var addedRules
      if ($scope.filteredRules.length <= offset + limit) {
        addedRules = angular.copy(
          $scope.filteredRules.slice(offset, $scope.filteredRules.length)
        )

        if ($scope.model.selectAllCheckbox) {
          angular.forEach(addedRules, function (rule) {
            rule.selected = true
            $scope.selectedRules.push(rule)
          })
        }

        $scope.displayedRules = $scope.displayedRules.concat(addedRules)
      } else {
        addedRules = angular.copy(
          $scope.filteredRules.slice(offset, offset + limit)
        )

        if ($scope.model.selectAllCheckbox) {
          angular.forEach(addedRules, function (rule) {
            rule.selected = true
            $scope.selectedRules.push(rule)
          })
        }

        $scope.displayedRules = $scope.displayedRules.concat(addedRules)
        $scope.model.busy = false
      }

      $timeout(function () {
        $scope.$emit('triggerScrollCheck')
      })
    }

    function order(rowName) {
      if ($scope.model.row === rowName) {
        return
      }
      $scope.model.busy = true

      var rulesDisplayed = $scope.displayedRules.length

      $scope.model.row = rowName
      $scope.displayedRules = []
      $scope.selectedRules = []
      $scope.model.selectAllCheckbox = false

      var deferred = $q.defer()
      $scope.promise = deferred.promise
      $interval(
        function () {
          $scope.displayedRules = []
          calculateRules(_searchKeywords)
          loadRules(0, rulesDisplayed)
          deferred.resolve('')
        },
        delay,
        1
      )
    }

    function onSelectAll() {
      if ($scope.model.selectAllCheckbox) {
        selectAll()
      } else {
        deselectAll()
      }
    }

    function selectAll() {
      $scope.selectedRules = []
      angular.forEach($scope.filteredRules, function (rule) {
        if (rule.type !== 'Virtual Patch') {
          rule.selected = true
          $scope.selectedRules.push(rule)
        }
      })

      return $scope.selectedRules
    }

    function deselectAll() {
      $scope.selectedRules = []
      angular.forEach($scope.filteredRules, function (rule) {
        rule.selected = false
      })

      return $scope.selectedRules
    }

    function toggleSelection(rule) {
      var idx = $scope.selectedRules.indexOf(rule)

      if (idx > -1) {
        $scope.selectedRules.splice(idx, 1)
      } else {
        $scope.selectedRules.push(rule)
      }

      $scope.model.selectAllCheckbox =
        $scope.selectedRules.length === $scope.filteredRules.length

      return $scope.selectedRules
    }

    function calculateRules(currentSearchKeywords) {
      var newRules

      // order
      if ($scope.model.row === 'type') {
        newRules = angular.copy($scope.rules).sort(function (first, second) {
          var order =
            typeOrder.indexOf(first.type) - typeOrder.indexOf(second.type)
          if (order === 0) {
            return first.description.localeCompare(second.description)
          }
          return order < 0 ? -1 : 1
        })
      } else if ($scope.model.row === '-type') {
        newRules = angular.copy($scope.rules).sort(function (first, second) {
          var order =
            typeOrder.indexOf(second.type) - typeOrder.indexOf(first.type)
          if (order === 0) {
            return second.description.localeCompare(first.description)
          }
          return order < 0 ? -1 : 1
        })
      } else {
        newRules = $filter('orderBy')($scope.rules, $scope.model.row, false)
      }

      // filter by keywords
      if (currentSearchKeywords.length > 0) {
        newRules = $filter('filter')(
          newRules,
          filterFunction,
          currentSearchKeywords
        )
      }

      $scope.filteredRules = newRules
      $scope.ruleParentIds = getUniqueParentIds(newRules)
    }

    function moveToServer(env) {
      var environment = undefined
      if (env) {
        var envConfig = _.find(SERVER_ENVIRONMENT_LIST, function (item) {
          return item.name === env
        })
        environment = envConfig ? envConfig.value : undefined
      }
      LoadFilterRouteService.goToServersFilteredByApp($scope.appId, environment)
    }

    function typeSelected(rule, model, environment) {
      var index = _.findIndex(PROTECTION_MODES, function (mode) {
        return mode.value === model
      })

      var promiseConfigs = [
        {
          appId: $scope.appId,
          ruleId: rule.id,
          env: environment,
          level: index
        }
      ]

      if (model === 'BLOCKING_PERIMETER') {
        BlockingPerimeterModalService.openModal(promiseConfigs, getRules, false)
      } else {
        ProtectionRulesFactory.editEnvProtectionLevel(
          $scope.appId,
          rule.id,
          environment,
          index
        )
          .then(function () {
            var ruleIndex = _.findIndex($scope.rules, function (item) {
              return item.uuid === rule.uuid
            })

            if (ruleIndex != -1) {
              $scope.rules[ruleIndex] = rule
            }
          })
          .catch(ErrorService.processError)
      }
    }

    function checkPermission(permission) {
      return permissions.hasEnterprisePermission(permission)
    }

    function openChangeModeModal() {
      var modalInstance
      modalInstance = $uibModal.open({
        templateUrl: 'views/applications/settings/protection_modal.html',
        controller: 'ProtectionPolicyModalCtrl',
        size: 'md-sm',
        resolve: {
          appId: function () {
            return $scope.appId
          },
          rules: function () {
            return $scope.selectedRules
          },
          callback: function () {
            return getRules
          },
          enabledBP: function () {
            return _.every($scope.selectedRules, function (rule) {
              return rule.can_block_at_perimeter
            })
          },
          enabledMP: function () {
            return _.every($scope.selectedRules, function (rule) {
              return rule.is_monitor_at_perimeter
            })
          }
        }
      })

      modalInstance.result.then(function () {
        getRules()
      })
    }

    function calculateQuickFilters() {
      var transl = {
        title_protectRules: $translate.instant('title_protectRules'),
        title_cveShields: $translate.instant('title_cveShields'),
        title_virtualPatches: $translate.instant('title_virtualPatches')
      }

      $scope.quickFilters = []
      $scope.quickFilters.push({
        name: translGlobal.title_remediationPolicy_allRules,
        count: $scope.filteredRules.length,
        filterType: FILTER_TYPES.ALL
      })
      $scope.quickFilters.push({
        name: transl.title_protectRules,
        count: $filter('filter')(
          $scope.filteredRules,
          typeOrder[PROTECT_RULE_INDEX]
        ).length,
        filterType: FILTER_TYPES.PROTECT_RULE
      })
      $scope.quickFilters.push({
        name: transl.title_cveShields,
        count: $filter('filter')(
          $scope.filteredRules,
          typeOrder[CVE_SHIELD_INDEX]
        ).length,
        filterType: FILTER_TYPES.CVE_SHIELD
      })

      if (!UserService.isFreemiumOrganization()) {
        $scope.quickFilters.push({
          name: transl.title_virtualPatches,
          count: $filter('filter')(
            $scope.filteredRules,
            typeOrder[VIRTUAL_PATCH_INDEX]
          ).length,
          filterType: FILTER_TYPES.VIRTUAL_PATCH
        })
      }

      $scope.selectedQuickFilter = $scope.quickFilters.find(function (filter) {
        return filter.filterType === $scope.selectedQuickFilter.filterType
      })

      if ($scope.selectedQuickFilter.filterType !== 'ALL') {
        executeQuickFilter()
      }
    }

    function quickFilterSelect(filter) {
      $scope.displayedRules = []
      $scope.selectedRules = []
      $scope.model.selectAllCheckbox = false

      $scope.selectedQuickFilter = filter

      calculateRules(_searchKeywords)
      executeQuickFilter()
      loadRules(0, numPerLoaded)
    }

    function executeQuickFilter() {
      switch ($scope.selectedQuickFilter.filterType) {
        case 'PR':
          $scope.filteredRules = $filter('filter')(
            $scope.filteredRules,
            typeOrder[0]
          )
          break

        case 'CVE':
          $scope.filteredRules = $filter('filter')(
            $scope.filteredRules,
            typeOrder[1]
          )
          break

        case 'VR':
          $scope.filteredRules = $filter('filter')(
            $scope.filteredRules,
            typeOrder[2]
          )
          break

        default:
          break
      }
    }

    function loadByScroll() {
      $scope.model.busy = true
      if ($scope.displayedRules.length < $scope.filteredRules.length) {
        var deferred = $q.defer()
        $scope.policyPromise = deferred.promise
        //This timeout is to simulate the infinite scroll, until the pagination (offset and limit) is done in client side
        $interval(
          function () {
            loadRules($scope.displayedRules.length, numPerLoaded)
            deferred.resolve('')
          },
          delay,
          1
        )
      }
    }

    function determineNoServerTooltip(env) {
      $scope.tooltip_environment = env
      return 'views/tooltips/applications/appProtectionPolicyNoServerTooltip.html'
    }

    function determineNoProtectionTooltip(env) {
      $scope.tooltip_environment = env
      return 'views/tooltips/applications/appProtectionPolicyNoProtectionTooltip.html'
    }

    function isNewRule(ruleUuid, language) {
      var newRule = csBetaRulesService.getNewRule(ruleUuid, language)

      return angular.isDefined(newRule)
    }

    init()
  }
})()
